import { Fighter } from './fighter';
import type { FighterStats, FacingDirection } from '@/shared/types';
import { JUMP_FORCE, MAX_HEALTH, PLAYER_SPEED } from '@/shared/constants';

export class Spinosaurus extends Fighter {
  readonly name = 'SPINOSAURUS';
  readonly color = '#8c2d2d';

  readonly stats: FighterStats = {
    maxHealth: MAX_HEALTH,
    speed: PLAYER_SPEED * 1.1,
    jumpForce: JUMP_FORCE * 0.9,
    width: 135,
    height: 165,
    attacks: {
      bite: {
        type: 'bite',
        damage: 10,
        range: 105,
        startup: 5,
        active: 5,
        recovery: 8,
        hitBox: { x: 0, y: 23, width: 105, height: 53 },
      },
      'tail-swipe': {
        type: 'tail-swipe',
        damage: 10,
        range: 135,
        startup: 5,
        active: 7,
        recovery: 9,
        hitBox: { x: 0, y: 53, width: 135, height: 53 },
      },
      special: {
        type: 'special',
        damage: 22,
        range: 128,
        startup: 10,
        active: 8,
        recovery: 16,
        hitBox: { x: 0, y: 8, width: 128, height: 105 },
      },
    },
  };

  constructor(x: number, facing: FacingDirection) {
    super(x, facing);
  }
}
